import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=9810b3fc&scoped=true&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"
import style0 from "./Account.vue?vue&type=style&index=0&id=9810b3fc&scoped=true&lang=css&"
import style1 from "./Account.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9810b3fc",
  null
  
)

export default component.exports